import styled from 'styled-components'

import Flex from 'Components/UI/Flex'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { BLUEPRINT_WIDTH, PX_BLUEPRINT } from 'Constants/Landing'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

const Wrapper = styled(Flex)
  .attrs({
    width: 1,
    mx: PX_BLUEPRINT,
    maxWidth: BLUEPRINT_WIDTH,
  })
  .withConfig({
    shouldForwardProp,
  })``

export default Wrapper
